import type { SaveEvent } from 'containers/LeaveDialogue/LeaveDialog';
import type Immutable from 'immutable';
import {
  SAVE_BACKUP_FORM,
  SAVE_MAINTENANCE,
  SETTING_SYSTEM_CLEAR_DB,
  START_MAINTENANCE,
} from './constants';
import type { CronFormValue } from './types';

export type BackupFormSaveData = {
  returnUrl?: SaveEvent;
  data:
    | {
        type: 'local';
        enabled: string | boolean;
        cron: CronFormValue;
      }
    | {
        type: 'ftp' | 'sftp';
        enabled: string | boolean;
        cron: CronFormValue;
        server: string;
        username: string;
        password: string;
        directory: string;
      };
};

export type MaintenanceFormSaveData = {
  returnUrl?: SaveEvent;
  // Real shape in immutable map is:
  // {
  //   enabled: string | boolean;
  //   cron: CronFormValue;
  // }
  values: Immutable.Map<string, string | boolean | CronFormValue>;
};

export type ClearDbArgs = {
  keepSettings: boolean;
};

export function backupFormSave(payload: BackupFormSaveData) {
  return {
    type: SAVE_BACKUP_FORM,
    payload,
  };
}

export function maintenanceFormSave(payload: MaintenanceFormSaveData) {
  return {
    type: SAVE_MAINTENANCE,
    payload,
  };
}

export function startMaintenance() {
  return {
    type: START_MAINTENANCE,
  };
}

export function systemClearDb(args: ClearDbArgs) {
  return {
    type: SETTING_SYSTEM_CLEAR_DB,
    payload: args,
  };
}
